import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

/**
 * Guard preventing the page from activating only if the
 * return url parameter is provided
 */
@Injectable()
export class LoginEntryPageGuard 
{
    /**
     * Class constructor
     * @param router
     */
    constructor
        (
            private router: Router
        )
    {
    }

    /**
     * CanActivate method implementation, returning true if the page can 
     * be accessed or a URL tree if a redirection has to be done
     * @param route
     */
    canActivate(route: ActivatedRouteSnapshot)
    {
        let returnUrl = route.queryParams.param;

        if (returnUrl)
        {
            return true;
        }
        else
        {
            return this.router.parseUrl('/landing');
        }
    }
}